module.exports = __webpack_public_path__ + "img/20190412175107.b90d8bf1.png";